import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { ITemplates } from 'src/app/models/ITemplates';
import { TemplatesService } from 'src/app/Services/NewVisitNote/templates.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IMessagingSender } from 'src/app/models/IMessaging';
import { ProvidersListComponent } from 'src/app/ChildControls/providers-list/providers-list.component';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { NgxSpinnerService } from "ngx-spinner";

export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {

  }
}

@Component({
  selector: 'app-template-notes',
  templateUrl: './template-notes.component.html',
  styleUrls: ['./template-notes.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TemplateNotesComponent implements OnInit {
  catvisibility: boolean = true;
  tabVisibility: boolean = false;
  activetab = 1;
  activetabcat = 8;
  templateId = 0;
  selectedDefaultValue: string = 'all';
  categoryTabId: string;
  templateInfo: ITemplates;
  columnsToDisplay = ['templateName', 'notes', 'createdBy', 'action'];
  headercolumnsToDisplay = ['Template Name', 'Description', 'Created By', 'Action'];
  expandedElement: ITemplates | null;
  dataSource = new MatTableDataSource();
  categoryName: string = '';
  show: boolean = false;
  public result: any;
  public categoryId: any;
  public ispopup: boolean = false;
  public selectedTemplate: any = '';
  public provider: string = '';
  public showData: boolean = false;
  public chkshowall: boolean = true;
  public showAll: string = '';
  message: string = '';
  messages: IMessagingSender[] = [];
  // Same tokens as Dynamic Intake (USP_EMR_IntakeFormEncounter_getByEncounter) so substitution stays consistent
  macroVariables = [
    { label: 'Full Name', token: '[[FULLNAME]]' },
    { label: 'Mr.Last name / Ms. Last name', token: '[[Lastname]]' },
    { label: 'He/She', token: '[[He/She]]' },
    { label: 'he/she', token: '[[he/she]]' },
    { label: 'Age', token: '[[Age]]' },
    { label: 'Gender', token: '[[Gender]]' },
    { label: 'DOB', token: '[[DOB]]' },
    { label: 'herself/himself', token: '[[herself/himself]]' },
    { label: 'Him/Her', token: '[[Him/Her]]' },
    { label: 'him/her', token: '[[him/her]]' },
    { label: 'His/Her', token: '[[His/Her]]' },
    { label: 'his/her', token: '[[his/her]]' },
    { label: 'Previous Appointment Date', token: '[[Previous_Appointment_Date]]' },
    { label: 'Current Appointment Date', token: '[[Current_Appointment_Date]]' },
  ];
  showInfo() {
    this.Templateform.patchValue({
      providerId: this.selectedDefaultValue,
    });
    this.show = !this.show;
    this.clearformcontrolvalues();
    this.expandedElement = null;
  }

  Templateform: FormGroup;
  submitted = false;
  public templetList: ITemplates[];
  public physicianList: IUserDetails[];
  public providerChangeValue: string;
  public location: number = 0;
  constructor(private formBuilder: FormBuilder,
    private templateService: TemplatesService,
    private toastr: ToastrService
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private router: Router
    , public dialog: MatDialog
    , public dialogRef: MatDialogRef<TemplateNotesComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any
    , private sharedService: SharedService
    , private crypto: AESAlgorithm
  ) {
    if (this.location != 0 || this.location != undefined) {
      this.location = Number(sessionStorage.getItem("LocationId"))
    }

    this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');
      if (this.categoryId == '3') {
        this.activetabcat = 9;
      }
      else if (this.categoryId == '4') {
        this.activetabcat = 1;
      }
      else if (this.categoryId == '10') {
        this.activetabcat = 2;
      }
      else if (this.categoryId == '13') {
        this.activetabcat = 6;
      }
      else if (this.categoryId == '5') {
        this.activetabcat = 0;
      }
      else if (this.categoryId == '14') {
        this.activetabcat = 10;
      }
      else if (this.categoryId == '9') {
        this.activetabcat = 7;
      }
      else if (this.categoryId == '7') {
        this.activetabcat = 8;
      }
      else if (this.categoryId == '15') {
        this.activetabcat = 11;
      }
      else if (this.categoryId == '22') {
        this.activetabcat = 3;
      }
      else if (this.categoryId == '21') {
        this.activetabcat = 4;
      }
      else if (this.categoryId == '20') {
        this.activetabcat = 5;
      }
      else if (this.categoryId == '23') {
        this.activetabcat = 16;
      }
      else if (this.categoryId == '24') {
        this.activetabcat = 12;
      }
      else if (this.categoryId == '25') {
        this.activetabcat = 13;
      }
      else if (this.categoryId == '26') {
        this.activetabcat = 14;
      }
      else if (this.categoryId == '27') {
        this.activetabcat = 15;
      }
      this.tabVisibility = (params.get('istab') == 'true' ? true : false);
      this.templetList = [];
      if (this.categoryId > 0) {
        this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
      }
    });
    if (this.data != null) {
      if (this.data.id > 0) {
        this.categoryId = this.data.id;
        this.tabVisibility = this.data.istab;
        this.provider = this.data.provider;
        this.ispopup = this.data.ispopup;
        this.catvisibility = false;
        this.showData = this.data.showInfo;
        this.showAll = this.data.showData;
        if (this.chkshowall == true) {
          this.getTemplatesbyCategory(this.categoryId, this.provider, true, this.location);
        } else {
          this.getTemplatesbyCategory(this.categoryId, this.provider, false, this.location);
        }
      }
    }
  }
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    if (this.chkshowall == true) {
      this.getTemplatesbyCategory(this.categoryId, this.provider, this.chkshowall, this.location);
    }
    else {
      this.getTemplatesbyCategory(this.categoryId, this.provider, false, this.location);
    }
    this.Templateform = this.formBuilder.group({
      dataSource: [],
      templateName: ['', [Validators.required]],
      Description: ['',],
      notes: ['', [Validators.required]],
      providerId: [''],
      showAll: [''],
      searchControl: ['']
    });

    this.templateInfo = {
      templateId: null,
      templateName: '',
      templateCategoryId: null,
      templateDescription: '',
      notes: '',
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      dbOperation: '',
      category: '',
      providerId: '',
      locationId: null
    };
    this.getAllProviders();
    this.Templateform.markAllAsTouched();
    this.Templateform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.Templateform);

    });
    this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');
    });
  }

  showAllProviders(event: any) {
    if (this.data != null) {
      if (this.data.id > 0) {
        this.categoryId = this.data.id;
        this.provider = this.data.provider;
      }
    }

    if (event.target.checked) {
      this.getTemplatesbyCategory(this.categoryId, this.provider, true, this.location);
    }
    else {
      this.getTemplatesbyCategory(this.categoryId, this.provider, false, this.location);
    }
  }

  get f() { return this.Templateform.controls; }

  formErrors = {
    'templateName': '',
    'notes': '',
  };

  validationMessages = {
    'templateName': {
      'required': 'Name is required.',
    },
    'notes': {
      'required': 'Description is required.'
    }
  };

  onCancel(id: number) {
    if (id == 0) {
      this.show = false;
      this.clearformcontrolvalues();
    }
  }

  clearformcontrolvalues() {
    this.Templateform.patchValue({
      templateName: '',
      notes: '',
    });
    this.templateId = 0;
  }

  Templateslist: ITemplates[];
  getTemplatesbyCategory(id: number, provider: string, showAll: boolean, location: number) {
    this.spinner.show();
    this.templateService.getTemplatesbyCategory(id, provider, showAll, this.location)
      .subscribe(
        (data: any) => {
          this.templetList = data;
          if (this.templetList.length != 0) {
            if (this.templetList[0].category == 'OPERATIVE REPORT') {
              this.categoryName = ('Intra Operative' + '/' + 'Office Procedures ').toUpperCase() + ' Templates';

            } else {
              this.categoryName = (this.templetList[0].category).toUpperCase() + ' Templates';
            }
            this.dataSource.data = this.templetList;
          }
          else {
            this.dataSource.data = this.templetList;
          }
          setTimeout(() => {
            this.spinner.hide();
          }, 2000);
        }, (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

  DisableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.DisableAllFormControls(abstractControl);
      } else {
        abstractControl.disable();
      }
    });
  }

  EnableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.EnableAllFormControls(abstractControl);
      } else {
        abstractControl.enable();
      }
    });
  }

  logValidationErrors(group: FormGroup = this.Templateform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  onCancelElement(data: any) {
    if (data.templateId != 0) {
      this.show = !this.show;
    }
  }

  delInsInfo: string = "";
  oncellclick(element: ITemplates) {
    if (!this.ispopup) {
      if (this.delInsInfo === "delete" || this.delInsInfo === 'edit') {
        this.expandedElement = null
      } else {
        this.EnableAllFormControls(this.Templateform);
        this.Templateform.patchValue({
          templateName: element.templateName,
          notes: element.notes,
          templateCategoryId: element.templateCategoryId,
          modifiedOn: element.modifiedOn,
          providerId: element.providerId,
        });
        this.selectedTemplate = element;
        this.templateId = element.templateId;
        this.show = false;
      }
    }
    else {
      this.Templateform.patchValue({
        templateName: element.templateName,
        notes: element.notes,
        templateCategoryId: element.templateCategoryId,
        modifiedOn: element.modifiedOn,
        providerId: element.providerId,
      });
      this.selectedTemplate = element;
      this.data.selectednotes = this.selectedTemplate.notes;
    }
    if (element.providerId == null || element.providerId == undefined || element.providerId == "") {
      this.Templateform.patchValue({
        providerId: this.selectedDefaultValue,
      });
    } else {
      this.Templateform.patchValue({
        providerId: element.providerId,
      });
      this.selectedTemplate = element;
    }
  }

  mapFormValuesToTemplateModel() {
    this.templateInfo.templateName = this.Templateform.value.templateName;
    this.templateInfo.notes = this.Templateform.value.notes;
    this.templateInfo.templateCategoryId = this.categoryId;
    this.templateInfo.providerId = this.Templateform.value.providerId;
    this.templateInfo.locationId = this.location;
    if (this.templateId != 0) {
      this.templateInfo.dbOperation = 'Update';
      this.templateInfo.modifiedOn = this.Templateform.value.modifiedOn;
    }
    else
      this.templateInfo.dbOperation = 'Insert';
    this.templateInfo.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.templateInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();

  }

  onSubmit(id) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.Templateform.value.templateName === "" || this.Templateform.value.templateName === null || this.Templateform.value.templateName === undefined) {
      this.toastr.error('Template Name Required');
      return;
    }
    if (this.Templateform.value.notes === "" || this.Templateform.value.notes === null || this.Templateform.value.notes === undefined) {
      this.toastr.error('Description Required');
      return;
    }
    if (this.Templateform.invalid) {
      return;
    }

    var templist = this.templetList.filter(x => x.templateName === this.Templateform.value.templateName);
    this.templateInfo.templateId = id;
    this.mapFormValuesToTemplateModel();
    if (this.templateInfo.templateId) {
      var existTempUpdate = this.templetList.filter(x => x.templateId !== this.templateInfo.templateId);
      var existlist = existTempUpdate.filter(x => x.templateName == this.Templateform.value.templateName && x.providerId === this.Templateform.value.providerId);
      if (existlist.length > 0) {
        this.toastr.warning("Template Name already Exist");
        return;
      }
      this.templateService.editnotesTemplate(this.templateInfo).subscribe((results: any) => {
        this.result = results;
        this.show = false; this.expandedElement = null;
        this.toastr.success(this.result);
        this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
      });
    } else {
      if (templist.length > 0) {
        this.toastr.warning("Template Name already Exist");
        return;
      }
      this.templateService.addnotesTemplate(this.templateInfo).subscribe(
        results => {
          this.result = results;
          this.show = false;
          this.toastr.success(this.result);
          this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
        }
      );
    }
    this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
    this.templateId = 0;
  }

  onLinkClick(event: MatTabChangeEvent) {
    this.show = false;
    this.clearformcontrolvalues();
    event.tab.isActive = true;
    var catid = this.getPlanCategoryId(event.tab.textLabel);
    this.tabVisibility = true;
    this.router.navigateByUrl('/Template/' + catid + '/true');
  }

  getAllProviders() {
    this.sharedService.getAllUsersByRoleWithOutLocId("Doctor").subscribe(data => {
      this.physicianList = data;
    });
  }

  getPlanCategoryId(name) {
    var catId = '';
    switch (name) {
      case 'Patient Instructions':
        catId = '6';
        break;
      case 'Plan':
        catId = '3';
        break;
      case 'Internal Notes':
        catId = '8';
        break;
      default:
        catId = '3';
    }
    return catId;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    if (this.selectedTemplate.notes === undefined) {
      this.message = 'Please select any template'
    }
    else {
      this.dialogRef.close({
        selectednotes: this.selectedTemplate.notes
      });
    }
  }

  ondeleteclick(template, delNo) {
    this.delInsInfo = delNo;
    const message = "Are you sure to delete Template Information? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '120px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.expandedElement = null;
      this.delInsInfo = "";
      this.result = dialogResult;
      if (this.result) {
        this.templateService.deletenotesTemplate(template.templateId).subscribe(
          results => {
            this.result = results;
            this.toastr.success(this.result);
            this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
          }
        );
      }
      else {
        this.result = dialogResult;
      }
    });
  }

  ontabClick(event: MatTabChangeEvent) {
    this.show = false;
    this.clearformcontrolvalues();
    this.Templateform.patchValue({
      searchControl: ''
    });
    event.tab.isActive = true;
    var catid = this.getCategoryId(event.tab.textLabel);
    this.categoryTabId = catid;
    if (event.tab.textLabel != "Plan") {
      this.tabVisibility = false;
      this.router.navigateByUrl('/Template/' + catid + '/false');
    }
    else {
      this.tabVisibility = true;
      this.router.navigateByUrl('/Template/' + catid + '/true');
    }
  }

  getCategoryId(name) {
    var catId = '';
    switch (name) {
      case 'Plan':
        catId = '3';
        break;
      case 'ROS':
        catId = '4';
        break;
      case 'PE':
        catId = '10';
        break;
      case 'Pumps':
        catId = '13';
        break;
      case 'Chief Complaint':
        catId = '5';
        break;
      case 'Intra Operative/Office Procedures':
        catId = '14';
        break;
      case 'Discussions':
        catId = '9';
        break;
      case 'Follow-Up':
        catId = '7';
        break;
      case 'Pre Operative':
        catId = '15';
        break;

      case 'Cervical':
        catId = '22';
        break;

      case 'Thoracic':
        catId = '21';
        break;

      case 'Lumbar':
        catId = '20';
        break;

      case 'Post Operative':
        catId = '23';
        break;

      case 'Assessment':
        catId = '24';
        break;

      case 'OR Record':
        catId = '25';
        break;

      case 'Post Surgical':
        catId = '26';
        break;

      case 'Perioperative Orders':
        catId = '27';
        break;

      default:
        catId = '3';
    }
    return catId;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    //Filtering specific column data
    this.dataSource.filterPredicate = function (data: ITemplates, filter: string): boolean {
      return data.templateName.toLowerCase().includes(filter) || data.notes.toLowerCase().includes(filter) || data.createdBy.toLowerCase().includes(filter); //|| data.category.toLowerCase().includes(filter)
    };
    this.dataSource.filter = filterValue;
  }


  OnTransforPopUp(selectedRow: IMessagingSender, delNo): void {
    this.delInsInfo = delNo;
    const dialogRef = this.dialog.open(ProvidersListComponent, {
      width: '480px',
      height: '160px',
      data: selectedRow,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.expandedElement = null;
      this.delInsInfo = "";
      if (result && result != undefined)
        this.shareTemplate(this.selectedTemplate, result);
    });
  }

  shareTemplate(template: ITemplates, userId: any) {
    template.templateId = Number(this.selectedTemplate.templateId);
    template.templateName = this.selectedTemplate.templateName;
    template.templateCategoryId = this.selectedTemplate.templateCategoryId;
    template.notes = this.selectedTemplate.notes;
    template.templateDescription = this.selectedTemplate.templateDescription;
    template.providerId = encodeURIComponent(userId);
    this.templateService.addnotesTemplate(template).subscribe(
      results => {
        this.result = results;
        this.show = false;
        this.toastr.success(this.result);
        this.getTemplatesbyCategory(this.categoryId, this.provider, this.showData, this.location);
      }
    );
  }

  // 14 = Intra Operative/Office Procedures (EMR_TEMPLATE_CATEGORY); its macros use OR Record F-codes
  get isIntraOperative(): boolean {
    return Number(this.categoryId) === 14;
  }

  insertVariable(textarea: HTMLTextAreaElement, token: string) {
    if (this.ispopup || !textarea) return;
    const notes: string = this.Templateform.value.notes || '';
    const start = textarea.selectionStart != null ? textarea.selectionStart : notes.length;
    const end = textarea.selectionEnd != null ? textarea.selectionEnd : start;
    const before = notes.slice(0, start);
    const text = (before.length > 0 && !/\s$/.test(before) ? ' ' : '') + token + ' ';
    this.Templateform.patchValue({ notes: before + text + notes.slice(end) });
    const caret = start + text.length;
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(caret, caret);
    });
  }
  
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
}
